import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Overlay.scss'

import Loader from 'components/ui/Loader/Loader'


const Overlay = ({ children, isVisible, absolute }) => {
  const overlayStyleName = cx(s.overlay, {
    [s.active]: isVisible,
    [s.absolute]: absolute,
  })

  return (
    <div className={overlayStyleName}>
      <Loader />
      <div className={s.children}>
        {children}
      </div>
    </div>
  )
}

Overlay.propTypes = {
  isVisible: PropTypes.bool,
}


export default Overlay
